import { FC, useEffect, useState, useRef, useContext } from "react";
import FilterCheckboxes from "../filterCheckboxes";
import FilterDropdown from "../filterDropdown";
import StyledSelectSlider from "../styledSelectSlider";
import { SliderRange } from "../styledSelectSlider/StyledSelectSlider";

import useSearch from "../../hooks/useSearch";
import useDropdownValues from "../../utils/dropdownValues";
import StyledMultiselectDropdown from "../styledMultiselectDropdown/StyledMultiselectDropdown";

const FilterMenuSearchAdvanced: FC = () => {
  const {
    alcoholFilter,
    carFilter,
    currentChildrenFilter,
    desiredChildrenFilter,
    drugsFilter,
    ethnicityFilter,
    eyeColorFilter,
    hairColorFilter,
    heightFilter,
    hereForFilter,
    maritalStatusFilter,
    physicalAppFilter,
    occupationFilter,
    religionFilter,
    smokerFilter,
    zodiacSignFilter,
  } = useDropdownValues();
  const { setFilteredSearch, filteredSearch } = useSearch();

  const [selectedRange, setSelectedRange] = useState<SliderRange>({
    min: filteredSearch.minHeight,
    max: filteredSearch.maxHeight,
  });

  let timeout = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {
      setFilteredSearch({
        minHeight: selectedRange.min,
        maxHeight: selectedRange.max,
      });
    }, 350);
  }, [selectedRange]);

  return (
    <div className="FilterMenuSearchAdvanced w-full pb-6 space-y-6 md:pt-8 pt-4">
      <FilterCheckboxes
        label={hereForFilter.label}
        placeholderId="relationshipType"
        values={hereForFilter.options.map((x) => ({
          id: +x.id,
          name: x.name,
        }))}
        defaultSelected={filteredSearch.relationshipType.map((x) => +x)}
      />
      <div className="space-y-3">
        <div className="flex md:flex-row flex-col w-full space-y-3 md:space-y-0 pt-[18px]">
          <div className="md:w-2/3 w-full">
            <StyledSelectSlider
              label={heightFilter.label}
              range={{ min: 1, max: 26 }}
              selectedRange={selectedRange}
              setSelectedRange={setSelectedRange}
              displayTitleWidth={150}
              values={heightFilter.options.map((x) => ({
                value: x.id,
                title: x.name,
              }))}
            />
          </div>

          <div className="md:w-1/3 md:pl-[35px] w-full">
            <StyledMultiselectDropdown
              label={physicalAppFilter.label}
              values={physicalAppFilter.options}
              selectedValueIds={filteredSearch.AppPhysiqueId}
              onChange={(values) => {
                setFilteredSearch({
                  AppPhysiqueId: values
                    .filter((x: { id?: string }) => x.id)
                    .map((x: { id: string }) => x.id),
                });
              }}
            />
          </div>
        </div>

        <div className="flex md:flex-row flex-col w-full space-y-3 md:space-y-0">
          <div className="md:w-1/4 w-full">
            <StyledMultiselectDropdown
              selectedValueIds={filteredSearch.fumeurId}
              label={smokerFilter.label}
              values={smokerFilter.options}
              onChange={(values) => {
                setFilteredSearch({
                  fumeurId: values
                    .filter((x: { id?: string }) => x.id)
                    .map((x: { id: string }) => x.id),
                });
              }}
            />
          </div>
          <div className="md:w-1/4 w-full md:ml-[35px]">
            <StyledMultiselectDropdown
              selectedValueIds={filteredSearch.signeZodiaqueId}
              label={zodiacSignFilter.label}
              values={zodiacSignFilter.options}
              onChange={(values) => {
                setFilteredSearch({
                  signeZodiaqueId: values
                    .filter((x: { id?: string }) => x.id)
                    .map((x: { id: string }) => x.id),
                });
              }}
            />
          </div>

          <div className="md:w-1/4 md:ml-[35px] w-full">
            <StyledMultiselectDropdown
              selectedValueIds={filteredSearch.ethnieId}
              label={ethnicityFilter.label}
              values={ethnicityFilter.options}
              onChange={(values) => {
                setFilteredSearch({
                  ethnieId: values
                    .filter((x: { id?: string }) => x.id)
                    .map((x: { id: string }) => x.id),
                });
              }}
            />
          </div>
          <div className="md:w-1/4 md:ml-[35px] w-full">
            <StyledMultiselectDropdown
              selectedValueIds={filteredSearch.religionId}
              label={religionFilter.label}
              values={religionFilter.options}
              onChange={(values) => {
                setFilteredSearch({
                  religionId: values
                    .filter((x: { id?: string }) => x.id)
                    .map((x: { id: string }) => x.id),
                });
              }}
            />
          </div>
        </div>

        <div className="flex md:flex-row flex-col w-full space-y-3 md:space-y-0">
          <div className="flex md:flex-row w-full flex-col md:space-y-0 space-y-3">
            <div className="md:w-1/2 md:pr-[17.5px] w-full">
              <StyledMultiselectDropdown
                selectedValueIds={filteredSearch.etatCivileId}
                label={maritalStatusFilter.label}
                values={maritalStatusFilter.options}
                onChange={(values) => {
                  setFilteredSearch({
                    etatCivileId: values
                      .filter((x: { id?: string }) => x.id)
                      .map((x: { id: string }) => x.id),
                  });
                }}
              />
            </div>
            <div className="md:w-1/2 md:pl-[17.5px] w-full">
              <StyledMultiselectDropdown
                selectedValueIds={filteredSearch.enfantActuelId}
                label={currentChildrenFilter.label}
                values={currentChildrenFilter.options}
                onChange={(values) => {
                  setFilteredSearch({
                    enfantActuelId: values
                      .filter((x: { id?: string }) => x.id)
                      .map((x: { id: string }) => x.id),
                  });
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterMenuSearchAdvanced;
